import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { PostmessageExternalSender } from '../postmessage-api-external'

export const useContactStore = defineStore('contact', () => {
    const { t } = useI18n()

    const isOpen = ref<boolean>(false)
    const isDirty = ref<boolean>(false)
    const message = ref<string>('')

    const hasError = computed<boolean>(() => !message.value)

    function open(): void {
        isOpen.value = true
    }

    function close(): void {
        isOpen.value = false
    }

    function submit(): void {
        isDirty.value = true

        if (hasError.value) {
            return
        }

        const url = new URL('mailto:koen@impactus.today')
        url.searchParams.append('subject', t('Your question about your renovation request'))
        url.searchParams.append('body', message.value)

        new PostmessageExternalSender().openUrlEmbedded(url.toString().replaceAll('+', '%20'))
        $reset()
    }

    function $reset() {
        isOpen.value = false
        isDirty.value = false
        message.value = ''
    }

    return {
        isOpen,
        isDirty,
        hasError,
        message,
        open,
        close,
        submit,
    }
})
